import axios from 'axios'

export const auth = {
  namespaced: true,
  state: () => ({
    userIsAuthenticated: false
  }),

  mutations: {
    setAuth(state, status) {
      state.userIsAuthenticated = status
    }
  },
  actions: {
    async sign({ commit }, payload) {
      await axios
        .post(`/auth/`, payload.data)
        .then(res => {
          $cookies.set('wegow.auth_token', res.data.token)
          $cookies.set('wegow.access_token', res.data.access_token)
          $cookies.set('wegow.expiry_token', res.data.expiry_token)
          $cookies.set('wegow.refresh_token', res.data.refresh_token)
          commit('setAuth', true)
        })
        .catch(res => {
          commit('setAuth', false)
          if (res.status !== 401) {
            var errorMessage =
              res && res.data && res.data.detail && res.data.detail.length > 0
                ? res.data.detail
                : 'Ups, algo no ha ido bien'
            if (typeof window !== 'undefined') {
              if (typeof CustomEvent === 'function') {
                var event = new CustomEvent('showError', {
                  detail: {
                    text: errorMessage
                  }
                })
                window.dispatchEvent(event)
              }
            }
          }
        })
    },
    setAuth({ commit }, value) {
      commit('setAuth', value)
    }
  }
}
